import { gql } from 'apollo-angular';
import { workspaceUserItemFragment } from '../user/user.fragments';
import { workspaceViewerCanFragment } from '../workspace/workspace.fragments';

export const workspaceRoleFragment = gql`
  fragment WorkspaceRoleFragment on WorkspaceRole {
    id
    title
    accessLevel

    user {
      ...WorkspaceUserItem
    }

    workspace {
      id
      workspaceRoles {
        edges {
          node {
            id
            accessLevel
          }
        }
      }
      ...WorkspaceViewerCanFragment
    }
  }
  ${workspaceViewerCanFragment}
  ${workspaceUserItemFragment}
`;
